export const allowedCustomFields = [
    'Religion',
    'PG First Semester GPA',
    'PG Second Semester GPA',
    'PG Third Semester GPA',
    'PG Fourth Semester GPA',
    'PG Fifth Semester GPA',
    'PG Sixth Semester GPA',
    'PG Seventh Semester GPA',
    'PG Eighth Semester GPA',
    'Community',
    'GATE Score',
    'GATE Rank',
    'Entrance Exam Rank',
    'Year of Gap',
    'UG Year of Pass',
    'Diploma Year of Pass',
    '12th Year of Pass',
    '10th Year of Pass',
    'PG Year of Pass',
    'Are you looking for a job change ?',
    '10th Medium',
    'Work Experience',
    '12th Medium',
    'Gender ( Hardcoded )',
    'UG First Semester GPA',
    'Annual Family Income',
    'UG Second Semester GPA',
    'Type of Admission',
    'UG Third Semester GPA',
    'UG Fourth Semester GPA',
    'UG Fifth Semester GPA',
    'UG Sixth Semester GPA',
    'UG Seventh Semester GPA',
    'UG Eighth Semester GPA',
    'Historical Arrears Count',
    'Career Aspiration',
    'Residence Type',
    'Marital status'
]